/**
 * MUI TablePagination overrides.
 *
 * The global MuiInputBase override (components/form/inputBase.js) forces
 * `width: 100% !important` and `display: grid !important` onto every
 * `.MuiInputBase-root`. The rows-per-page Select is built on an InputBase, so
 * it inherits both and stretches to the full toolbar width — which pushes the
 * "1-1 of 1" text and the page buttons past the card edge and raises a
 * horizontal scrollbar. Re-narrow it to a content-sized dropdown.
 *
 * Target `.MuiInputBase-root`, NOT `.MuiTablePagination-input`. The latter is
 * a v4-era class that MUI 5.8 no longer puts in the DOM: the select's root
 * node renders as
 *
 *   <div class="MuiInputBase-root MuiInputBase-colorPrimary css-...">
 *
 * so a `.MuiTablePagination-input` rule matches nothing and the stretch
 * survives. (`.MuiTablePagination-select` does exist, but on the inner div,
 * not the root that carries the width.)
 *
 * The descendant selector under the always-applied `root` slot gives this two
 * classes against the InputBase override's one, so it wins on specificity
 * with both sides marked `!important`.
 */
const tablePagination = {
  styleOverrides: {
    root: {
      "& .MuiInputBase-root": {
        display: "inline-flex !important",
        width: "auto !important",
        minWidth: 0,
      },
      // Inner select div — inputBase's `input` slot pushes width:100% here too.
      "& .MuiTablePagination-select": {
        width: "auto !important",
      },
    },
  },
};

export default tablePagination;
